import React from 'react'
import baseStyles from './Base.module.css'
import PageStatus from '../PageStatus'
import { isPt, isEe, isTp } from '../lib/utils'
import Student from '../Student'

export default ({ path }) => {
    const { student } = Student.useContainer()
    return (
        <div className={baseStyles.root}>
            <h2>Taxe annuelle d'études</h2>
            <PageStatus path={path} />

            {(isEe(student) || isTp(student) || isPt(student)) && (
              <>
                <h3>Arrêt des études dès le 1<sup>er</sup> jour de cours du 1<sup>er</sup> semestre</h3>
                <p>
                  La taxe d'études d'un semestre + les contributions aux frais d'études sont dues dès le 1<sup>er</sup> jour de cours.
                </p>
              </>
            )}

            <h3>Arrêt des études dès le 1<sup>er</sup> jour de cours du 2<sup>ème</sup> semestre</h3>
            <p>La totalité de la taxe d'études et des contributions aux frais d'études sont dues dès le 1<sup>er</sup> jour de cours.</p>
            <p>&nbsp;</p>
            <p>
                Informations complémentaires relatives aux taxes – voir{' '}
                <a href="https://heig.ch/info-taxes" target="_blank" rel="noopener noreferrer">
                    ici
                </a>
            </p>
        </div>
    )
}
